import type {ThemeIconKey} from 'platform/foundation';

import type {FinancialProductType} from 'features/financial-products';

export const FINANCIAL_PRODUCT_TYPE_ICONS: Record<FinancialProductType, ThemeIconKey> = {
  STANDARD: 'action/deposit_payment',
  BALLOON: 'action/account_balance_wallet',
  LEASING: 'maps/directions_car',
};
